/**
 * Hero ortidagi takrorlanuvchi arabesque tile — opacity past, dekorativ.
 */
export default function HeroPatternOverlay({ opacity = 0.06, className = '' }) {
  return (
    <div
      className={`pointer-events-none absolute inset-0 ${className}`}
      style={{
        backgroundImage: 'url(/patterns/arabesque-tile.svg)',
        backgroundSize: '180px 180px',
        backgroundRepeat: 'repeat',
        opacity,
        color: '#FFFFFF',
        maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 80%)',
        WebkitMaskImage: 'radial-gradient(ellipse at center, black 30%, transparent 80%)',
      }}
      aria-hidden="true"
    />
  )
}
